import { EmploymentType, WorkplaceType } from '@/queries/types';

export const formatPublishedDate = (date: string) => {
  const published = new Date(date);
  const now = new Date();

  published.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);

  const diffTime = now.getTime() - published.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return 'Published today';
  }
  if (diffDays < 30) {
    return `Published ${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
  }

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) {
    return `Published ${diffMonths} month${diffMonths === 1 ? '' : 's'} ago`;
  }

  const diffYears = Math.floor(diffMonths / 12);
  return `Published ${diffYears} year${diffYears === 1 ? '' : 's'} ago`;
};

export const WORKPLACE_TYPE_LABELS: Record<WorkplaceType, string> = {
  remote: 'Remote',
  hybrid: 'Hybrid',
  onsite: 'On-site',
};

export const EMPLOYMENT_TYPE_LABELS: Record<EmploymentType, string> = {
  fullTime: 'Full time',
  partTime: 'Part time',
  contract: 'Contract',
  freelance: 'Freelance',
  internship: 'Internship',
  temporary: 'Temporary',
};

export const getHostnameFromApiUrl = (apiUrl: string): string => {
  const regex = /https:\/\/api\.hire\.(.*?)(toggl)\.(space|com)/;
  const transformed = apiUrl.replace(regex, '$1$2hire.$3');
  return transformed;
};
